<template>
  <section id="higher" v-if="ready">
    <b-container fluid>
      <b-row class="header">
        <b-card overlay :img-src="require(`../../assets/images/higher/background.jpg`)" img-alt="Prepack Planner Background" text-variant="white">
          <div class="aspect-ratio"></div>

          <b-card-text class="headline">
            <parallax id="surfer"><b-img fluid :src="require(`../../assets/images/higher/climber.png`)"></b-img></parallax>
            <h1 v-bind:class="{ blur: blurheadline }" class="small">A Trade in Program with</h1>
            <h1 v-bind:class="{ blur: blurheadline }" class="large">Higher</h1>
            <h1 v-bind:class="{ blur: blurheadline }" class="small bottom">Returns</h1>
          </b-card-text>
        </b-card>
      </b-row>

      <div class="row bottomline">
        <div class="col-lg-9" data-aos="fade-right">
          <h2>Helping to Bring Bottom Lines to <br /><span>New Heights</span></h2>
          <h3>The 3M Canada Trade in, Trade Up Rebate Program</h3>
          <div class="para">
            <p>Working at heights means putting yourself at risk every day while on the job. Relying on the right equipment isn’t a choice; it’s a necessity. The real challenge here is providing options to help get the best gear available on the market to those who need it most.</p>
            <p>That’s where the Trade in, Trade up Rebate Program comes in. It’s part equipment trade-in program and part sales enablement, adding up to a powerful tool in the 3M Canada toolkit.</p>
            <p>We breathed new life into an aging process in the form of a trade-in submission portal. The bulk of these updates were focused on:</p>
            <ol>
              <li>Making the rebate process easier.</li>
              <li>Enabling easier competitor product switching.</li>
              <li>Creating a more user-friendly experience for workers.</li>
            </ol>
          </div>
        </div>
        <div class="col-lg-3" data-aos="fade-left">
          <b-img fluid :src="require(`../../assets/images/higher/Group 27487.png`)"></b-img>
        </div>
      </div>

      <div class="cover">
        <b-img class="welltimed-bg" fluid :src="require(`../../assets/images/higher/trade_n-social.png`)"></b-img>
        <div class="row welltimed">
          <div class="col-md-6 timed" data-aos="fade-right">
            <h3>Well-timed and targeted.</h3>
            <p>An omni-channel campaign was also developed to help make the launch of this updated program a big success. Amplification through social ads and channel posts, well-timed publication ads, a personalized email campaign and online marketing videos helped to build buzz with the right audience and drive traffic to the web-based app Branton developed for the program.</p>
          </div>

          <div class="col-md-6 offset-lg-6" data-aos="fade-left">
            <b-img class="ipad" fluid :src="require(`../../assets/images/higher/tradeIn-social-ipad.png`)"></b-img>
          </div>
        </div>
      </div>

      <div class="row elevating">
        <div class="col-md-7 col-lg-6 order-md-2 content" data-aos="fade-left">
          <h3>Elevating the experience.</h3>
          <p>Combining AI-powered machine reading, a visual customer journey, and well-placed digital touchpoints brought this successful program together, creating a new and improved experience for workers at heights to trade in the old for the new.</p>
          <p>An awareness campaign video was produced and deployed that helped generate interest and traffic to the portal. Once there, an instructional video facilitated the process for new visitors by educating them on the new system and how to get started on their trade in journey.</p>

          <b-img class="clickme" fluid @click="$bvModal.show('modal-footer-lg')" :src="require(`../../assets/images/higher/button.svg`)"></b-img>

          <div>
            <b-modal id="modal-footer-lg" size="xl" centered modal-cancel="dude">
              <div class="modal-body-full">
                <iframe src="https://player.vimeo.com/video/938588702?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&byline=0&portrait=0&share=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="width:100%;height:100%;" title="Trade In Trade Up Instructional Video"></iframe>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="col-md-5 col-lg-6 order-md-1" data-aos="fade-right">
          <b-img class="imac" fluid :src="require(`../../assets/images/higher/Group 27486.png`)"></b-img>
        </div>
      </div>
    </b-container>

    <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">
      <h4>See work <span>that matters.</span></h4>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[0] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/universe" class="content">
            <span class="projecttype dark">APP DEVELOPMENT</span>
            <span class="otherprojecthead dark">Unilux VFC</span>
            <span class="changeme dark">Control your universe.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/universe-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[1] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/winning" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Electrical</span>
            <span class="changeme">Uncover the secret.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/winning-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[2] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/clarity" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Clarity</span>
            <span class="changeme">Smiles for miles.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/clarity-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[3] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/surface" class="content">
            <span class="projecttype dark">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead dark">3M Food Safety</span>
            <span class="changem dark">See beyond the surface.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/surface-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[4] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/prepack-planner" class="content">
            <span class="projecttype">APP DEVELOPMENT</span>
            <span class="otherprojecthead">McCormick Display Strategy</span>
            <span class="changeme">Displays to order.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/prepack-other.png`)" alt="Your image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy";

//AOS Animations
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  components: {
    Parallax,
  },
  data() {
    return {
      hover: false,
      ready: false,
      blurheadline: false,
      isActive: false,
      activeStates: {},
    };
  },
  metaInfo: {
    titleTemplate: "Helping to Bring Bottom Lines to New Heights | Branton  — a Creation Company.",
    meta: [
      {
        name: "Our Work",
        content: "The 3M Canada Trade in, Trade Up Rebate Program, created by Branton. Making the rebate process easier.",
      },
    ],
  },
  methods: {
    initializeObservers() {
      const elements = this.$el.querySelectorAll(".preview-text-container");
      if (elements.length === 0) {
        console.error("No elements found");
        return;
      }
      elements.forEach((element, index) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
              this.$set(this.activeStates, index, entry.isIntersecting);
            });
          },
          { threshold: 1 }
        );

        observer.observe(element);
      });
    },

    handleScroll() {
      if (window.scrollY > 200) {
        this.blurheadline = true;
      } else {
        this.blurheadline = false;
      }
    },
    toggleActive(event) {
      event.currentTarget.classList.toggle("active");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeObservers();
    });

    this.ready = true;

    this.$gtag.pageview({
      page_path: "/work/higher",
    });

    if (this.ready) {
      AOS.init();
      AOS.refresh();
      setTimeout(
        function() {
          AOS.refresh();
        }.bind(this),
        300
      );
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/higher.scss";

div#surfer {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
</style>
